import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

export default function RatingStars({ question }) {
  const applyRating = useCallback((answer) => {
    $(`#${answer}`).tap();
  }, []);

  const onStarClick = useCallback(
    (e) => {
      const answer = $(e.target).attr('data-answer');
      const activeStarIndex = $(e.target).attr('data-active-star');
      applyRating(answer);
      setActiveStars(activeStarIndex);
    },
    [applyRating],
  );
  const [activeStars, setActiveStars] = useState(0);

  return (
    <div className="rating-stars">
      {question.answers.map((answer, index) => (
        <div className="rating-stars__star">
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */}
          <span
            className={`rating-stars__symbol icon-star-o ${
              activeStars > index ? 'icon-star' : ''
            }`}
            data-answer={answer.id}
            data-active-star={index + 1}
            onClick={onStarClick}
          />
        </div>
      ))}
    </div>
  );
}

RatingStars.propTypes = {
  question: PropTypes.object.isRequired,
};
